import { Controller } from "@hotwired/stimulus"

// Syncs the category edit page H1 with the name field (textContent only; no innerHTML).
// The name field lives inside the tab turbo frame (edit tab only); turbo:frame-load re-syncs
// when that frame loads so the title matches after switching tabs.
export default class extends Controller {
  static targets = ["title", "nameInput"]

  connect() {
    this.boundOnFrameLoad = () => {
      queueMicrotask(() => this.syncFromDom())
    }
    this.element.addEventListener("turbo:frame-load", this.boundOnFrameLoad)
    this.syncFromDom()
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.boundOnFrameLoad)
  }

  syncFromEvent(event) {
    if (!this.hasNameInputTarget) return
    if (event.target !== this.nameInputTarget) return
    this.applyTitle(event.target.value)
  }

  syncFromDom() {
    if (!this.hasNameInputTarget) return
    this.applyTitle(this.nameInputTarget.value)
  }

  applyTitle(raw) {
    if (!this.hasTitleTarget) return
    const name = (raw ?? "").trim()
    this.titleTarget.textContent = name.length > 0 ? `Edit ${name}` : "Edit Category"
  }
}
